import React from 'react';
import { Anchor } from '@mantine/core';

interface LabelWithLinkProps {
  labelText: string;
  linkText: string;
  onLinkClick: (e: React.MouseEvent) => void;
}

export const createLabelWithLink = ({ labelText, linkText, onLinkClick }: LabelWithLinkProps) => {
  const styles = {
    label: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  };

  const label = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <span>{labelText}</span>
      <Anchor
        href="#"
        size="xs"
        onClick={onLinkClick}
        onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
        onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
      >
        {linkText}
      </Anchor>
    </div>
  );

  return { styles, label };
};
